const STORE_NAME = import.meta.env.VITE_REACT_APP_NAME as string;

/**
 * customer metafield(info.cart_id)에 cartId 저장
 */
export const requestCartSync = async ({
  customerId,
  cartId,
  accessToken,
  domain,
}: {
  customerId: string;
  cartId: string;
  accessToken: string;
  domain: "ko" | "en" | "jp";
}): Promise<boolean> => {
  const url =
    "https://5scx2a6km4gzfixgnymablbwi40vmycp.lambda-url.ap-northeast-2.on.aws/"; // common_cart_sync
  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        storeName: STORE_NAME,
        domain,
        customerId,
        cartId,
        accessToken,
      }),
    });
    if (response.status !== 200) {
      console.error(
        "[CART SYNC] save cartId failed",
        response.status,
        await response.text(),
      );
      return false;
    }
    return true;
  } catch (error) {
    console.error("[CART SYNC] save cartId failed", error);
    return false;
  }
};
